// extracted by mini-css-extract-plugin
module.exports = {"entityMention":"EntityMentionExtension_entityMention__1b5Rp"};